import { render } from "./studioManage.vue?vue&type=template&id=c0bb56d4&scoped=true"
import script from "./studioManage.vue?vue&type=script&lang=js"
export * from "./studioManage.vue?vue&type=script&lang=js"

import "./studioManage.vue?vue&type=style&index=0&id=c0bb56d4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0bb56d4"]])

export default __exports__